/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { useReactForm } from "../react-hook/use-react-form";
import { IconRender } from "@/components/shared/Icon-render";
import { ErpSku } from "../user-input/erp-sku";
import { SelectWithSearch } from "@/components/form-input";
import { RequiredInput } from "@/components/shared/required-input";

type UserFormType = {
  formData: any;
  onOpenChange: (prop: any) => void;
  onFormSubmit: (prop: boolean) => Promise<void>;
  open: boolean;
  companyData: any;
  retailerList: any;
  searchErpSku: (prop: string) => Promise<void>;
};
export const ReactForm = ({
  formData,
  onOpenChange,
  onFormSubmit,
  open,
  retailerList,
  searchErpSku,
}: UserFormType) => {
  const { form, onSubmit, updateErpSkuName, erpUomChange } = useReactForm({
    formData,
    onOpenChange,
    onFormSubmit,
    open,
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="grid grid-cols-2 gap-x-6 gap-y-5 px-6">
          <FormField
            control={form.control}
            name="product_name"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  Product name
                  <RequiredInput />
                </FormLabel>
                <FormControl>
                  <Input placeholder="Product name" {...field} />
                </FormControl>

                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="retailer_id"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  Retailer Name
                  <RequiredInput />
                </FormLabel>
                <FormControl>
                  <SelectWithSearch
                    options={retailerList}
                    placeholder="Retailer Name"
                    value={field.value}
                    onChange={field.onChange}
                    bindLabel="retailer_name"
                    bindValue="retailer_id"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="po_sku"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Po Sku</FormLabel>
                <FormControl>
                  <Input
                    // disabled={formData ? true : false}
                    placeholder="Po Sku"
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="erp_sku_code"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Erp Sku</FormLabel>
                <FormControl>
                  <ErpSku
                    placeholder="Select erp sku"
                    onChange={field.onChange}
                    onSearch={searchErpSku}
                    value={field.value}
                    onBlur={field.onBlur}
                    bindLabel="erp_sku_name"
                    bindValue="erp_sku_code"
                    onValueChange={updateErpSkuName}
                    onAllValueChange={erpUomChange}
                    defaultValue={
                      formData?.erp_sku_name && formData?.erp_sku_code
                        ? [
                            {
                              erp_sku_name: formData?.erp_sku_name,
                              erp_sku_code: formData?.erp_sku_code,
                            },
                          ]
                        : []
                    }
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
        <hr className="mt-5" />
        <DialogFooter className="p-6 flex !justify-start">
          <Button
            type="submit"
            className="w-[160px]"
            disabled={form.formState.isSubmitting}
          >
            {form.formState.isSubmitting ? (
              <IconRender
                name="LoaderCircle"
                className="w-5 animate-spin text-white zoom-in-150"
              />
            ) : (
              "Save"
            )}
          </Button>
          <Button
            type="button"
            onClick={() => onOpenChange(false)}
            variant={"outline"}
            className="w-[160px]"
          >
            Close
          </Button>
        </DialogFooter>
      </form>
    </Form>
  );
};
